// ANGULAR & 3rd PARTIES
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TranslateModule } from '@ngx-translate/core';

// eUI IMPORTS
import {
    CoreModule,
    EUI_CONFIG_TOKEN,
    LocalStorageService,
    StorageService,
    translateConfig,
} from '@eui/core';
// import { UxBreadcrumbsService } from '@eui/components';
import { appConfig } from '../config/index';
import { environment } from '../environments/environment';
// APP ROUTES & ROOT COMPONENTS
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
// CSDR CORE - Babel defs & core reducers
import { CustomSerializer } from './reducers/custom-route-serializer';
import { TOKEN, metaReducers, reducerProvider } from './reducers/index';
// APP RELATED
import { provideIonicAngular } from '@ionic/angular/standalone';
import { AgmInitializationModule } from '@pmob/agm';
import { CoreModule as AppCoreModule } from '@pmob/core';
import { JsisInitializationModule } from '@pmob/jsis';
import { MipsInitializationModule } from '@pmob/mips';
import { MnetInitializationModule } from '@pmob/mnet';
import {
    SharedModule as AppSharedModule,
    menuReducer,
    menuStateSelector,
    notificationListReducer,
    notificationListStateSelector,
} from '@pmob/shared';
import { SysperInitializationModule } from '@pmob/sysper';
import { CoreAppEffects } from './core.effects';
import { provideCsdrCore } from '@csdr/core';
import { FilipHttpInterceptor, FilipInitializationModule } from '@pmob/filip';

// APP ROOT MODULE
@NgModule({
    imports: [
        BrowserModule,
        HttpClientModule,
        StoreRouterConnectingModule.forRoot({
            stateKey: 'router',
            serializer: CustomSerializer,
        }),
        StoreModule.forRoot(TOKEN, { metaReducers }),
        EffectsModule.forRoot([CoreAppEffects]),
        StoreDevtoolsModule.instrument({
            name: 'CSDR App',
            maxAge: 150,
            logOnly: environment.production,
        }),
        // TranslateModule.forRoot({ loader: { provide: TranslateLoader, useClass: BabelLoader } }),
        TranslateModule.forRoot(translateConfig),
        CoreModule.forRoot(),
        AppCoreModule.forRoot(),
        AppSharedModule,
        AppRoutingModule,
        // PMOB Initialization
        JsisInitializationModule,
        MipsInitializationModule,
        AgmInitializationModule,
        SysperInitializationModule,
        MnetInitializationModule,
        SysperInitializationModule,
        FilipInitializationModule,
        StoreModule.forFeature(menuStateSelector, menuReducer),
        StoreModule.forFeature(
            notificationListStateSelector,
            notificationListReducer,
        ),
        //  *****************
    ],
    declarations: [AppComponent],
    providers: [
        provideIonicAngular(),
        provideCsdrCore(),
        reducerProvider,
        // UxBreadcrumbsService,
        {
            provide: EUI_CONFIG_TOKEN,
            useValue: { appConfig: appConfig, environment: environment },
        },
        // { provide: BABEL_API_CONFIG_TOKEN, useFactory: getBabelApiConfig, deps: [CONFIG_TOKEN] },
        // { provide: BABEL_LOADER_CONFIG_TOKEN, useFactory: getBabelLoaderConfig, deps: [CONFIG_TOKEN] }
        LocalStorageService,
        { provide: StorageService, useExisting: LocalStorageService },
        /*        {
            provide: HTTP_INTERCEPTORS,
            useClass: OpenIdConnectInterceptor,
            multi: true,
        },*/

        {
            provide: HTTP_INTERCEPTORS,
            useClass: FilipHttpInterceptor, // MockHttpInterceptor,
            multi: true,
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
